
  import VueSlickCarousel from 'vue-slick-carousel'
  import 'vue-slick-carousel/dist/vue-slick-carousel.css'
  // optional style for arrows & dots
  import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

  export default {
    name: 'BlogSectionBanner',

    components: { VueSlickCarousel },

    props: {
      data: {
        type: Array,
        default: () => [],
      },
    },

    data() {
      return {
        settings: {
          arrows: true,
          dotsClass: "slick-dots dots-container",
          dots: true,
          adaptiveHeight: true,
          autoplay: false,
          lazyLoad: 'progressive',
          responsive: [
            {
              breakpoint: 768,
              settings: {
                  arrows: false,
              },
            },
          ]
        }

      }
    },
  }
